import React, { useRef, useState } from "react";
import styles from '../styles/transfer.module.scss'
import SelectField from "./selectField";
import Form from "@/wmCompoments/form";
import AmountField from "./amountField";
import SubmitButton from "@/modals/login/submitButton";
import { useAutoTransfer, useTransfer } from "../hooks/useApi";
import PromptDialog from "../dialog/ promptDialog";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import { useGetBalanceData, useUserInfo, useVenueBalanceList } from "@/api/request";
import Switch from "@/wmCompoments/switch";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";



const Transfer = () => {
    const { t } = useTranslation('transferCenter')

    const { trigger, isMutating: mutatingTransfer } = useTransfer()
    const [values, setValues] = useState<any>()
    const { mutate: mutateVenueBalance, isValidating: mutatingVenueBalance } = useVenueBalanceList()
    const { mutate: mutateBalance, isValidating: mutatingBalance } = useGetBalanceData()
    const { data: user, mutate: mutateUser } = useUserInfo()
    const { trigger: triggerAutoTransfer } = useAutoTransfer()
    const [autoTransferPopup, setAutoTransferPopup] = useState(false)
    const [promptDetail, setPromptDetail] = useState({
        visible: false,
        message: ''
    })
    const formRef = useRef<any>(null)

    const handleSubmit = async (isActivity: boolean) => {
        const { select, amount } = values
        const ty = select?.left?.id === 0 ? '1' : '2'
        try {

            const channelCode = ty === '1' ? select?.right?.channelCode : select?.left?.channelCode
            await trigger({
                amount,
                channelCode: channelCode,
                isActivity,
                ty
            })
            const _ = await Promise.all([mutateBalance(), mutateVenueBalance()])
            Toast.show(t('transferSuccess'))
            formRef.current?.set('amount', '')
        } catch (error: any) {
            //转入流水提示
            if (isActivity || ty === '2') {
                ErrorMessageDialog(error?.message)
            } else if (error?.status_code === 6413) {
                setPromptDetail({
                    visible: true,
                    message: error?.message
                })
            }else {
                ErrorMessageDialog(error?.message)
            }

        }
    }

    const checked = user?.status === '1'

    const handleAutoTransfer = async () => {
        try {
            await triggerAutoTransfer({})
            await mutateUser()
            Toast.show(t('operationSuccess'))
        } catch (error: any) {
            ErrorMessageDialog(error?.message || JSON.stringify(error))
        }
    }

    return <div className={styles.warpper}>
        <div>
            <span>{t('transferVenue')}</span>
            <div className={styles.switchWarpper}>
                <span>{t('autoTransfer')}</span>
                <Switch onChange={(v) => {
                    setAutoTransferPopup(true)
                }} checked={checked} className={styles.switch} />
            </div>
        </div>


        {!checked && <div>
            <Form
                ref={formRef}
                onSubmit={() => handleSubmit(false)} onValuesChange={(v) => {
                    setValues(v)
                }}>
                <SelectField name="select" />
                <AmountField name="amount" selectName="select" />

                <div className={styles.button}>
                    <SubmitButton text={t('submit')} loading={mutatingTransfer || mutatingVenueBalance || mutatingBalance} />
                </div>
            </Form>

        </div>}

        <PromptDialog
            onClose={() => {
                setPromptDetail({
                    ...promptDetail,
                    visible: false
                })
            }}
            onSubmit={async () => handleSubmit(true)}
            visible={promptDetail.visible} message={promptDetail.message} />


        <PromptDialog visible={autoTransferPopup} showHead={false}
            onSubmit={async () => handleAutoTransfer()}
            onClose={() => setAutoTransferPopup(false)}
            message={checked ? t('disableAutoTransfer') : t('enableAutoTransfer')}
        />
    </div>
}

export default Transfer